import { useState as w, useEffect as y } from "react";
import { j as E } from "./vendor.BnkHStSV.cacheable.js";
const m = /* @__PURE__ */ new Map();
function x(r) {
  const e = document.querySelector(
    `script[src="${r}"]`
  ), d = e == null ? void 0 : e.getAttribute("data-status");
  return {
    node: e,
    status: d
  };
}
function L(r, e) {
  const {
    async: d = !0,
    defer: u = !1,
    type: c = "module",
    skip: a = !1
  } = e ?? {}, [f, v] = w(() => !r || e != null && e.shouldPreventLoad ? "idle" : typeof window > "u" ? "loading" : a ? "ready" : m.get(r) ?? "loading");
  return y(() => {
    if (!r || e != null && e.shouldPreventLoad || a)
      return;
    const n = m.get(r);
    if (n === "ready" || n === "error") {
      v(n);
      return;
    }
    const S = x(r);
    let t = S.node;
    if (t)
      v(S.status ?? n ?? "loading");
    else {
      t = document.createElement("script"), t.src = r, t.async = d, t.type = c, t.defer = u, e != null && e.id && (t.id = e.id), t.setAttribute("data-status", "loading"), document.body.appendChild(t);
      const s = (i) => {
        const b = i.type === "load" ? "ready" : "error";
        t == null || t.setAttribute("data-status", b);
      };
      t.addEventListener("load", s), t.addEventListener("error", s);
    }
    const l = (s) => {
      const i = s.type === "load" ? "ready" : "error";
      v(i), m.set(r, i);
    };
    return t.addEventListener("load", l), t.addEventListener("error", l), () => {
      t && (t.removeEventListener("load", l), t.removeEventListener("error", l)), t && (e != null && e.removeOnUnmount) && (t.remove(), m.delete(r));
    };
  }, [
    r,
    e == null ? void 0 : e.shouldPreventLoad,
    e == null ? void 0 : e.removeOnUnmount,
    e == null ? void 0 : e.id,
    d,
    c,
    u,
    a
  ]), f;
}
const k = ({
  src: r,
  webComponent: e,
  scriptOptions: d,
  onPropsChange: u,
  children: c,
  ...a
}) => {
  const f = L(r, {
    type: "module",
    async: !0,
    skip: !1,
    defer: !1,
    ...d
  });
  return y(() => {
    f === "ready" && (u == null || u(a));
  }, [u, a, f]), /* @__PURE__ */ E.jsx(e, { ...a, children: c });
};
function U({
  src: r,
  scriptOptions: e,
  onPropsChange: d,
  componentProps: u
}) {
  const c = L(r, {
    type: "module",
    async: !0,
    skip: !1,
    defer: !1,
    ...e
  });
  y(() => {
    c === "ready" && (d == null || d(u));
  }, [u, d, c]);
}
const F = ({
  children: r,
  src: e,
  scriptOptions: d,
  ...u
}) => (U({
  src: e,
  scriptOptions: d,
  componentProps: u,
  onPropsChange: (c) => {
    var a;
    return (a = window == null ? void 0 : window.unifiedNav) == null ? void 0 : a.bootstrap(c);
  }
}), /* @__PURE__ */ E.jsx("unified-nav", { product: u.product, children: r }));
export {
  k as UnifiedComponent,
  F as UnifiedNavReact,
  L as useScript
};
